import { ReactElement, useContext } from 'react';
import { useRouter } from 'next/router';
import { Trans, useTranslation } from 'next-i18next';
import { Button, Link } from '@Hotels-at-Home/hah-fe-core/dist/components';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';
import { useWindowSize } from '@Hotels-at-Home/hah-fe-core/dist/hooks';
import { MD_WIDTH } from '@Hotels-at-Home/hah-fe-core/dist/constants';

import { sitewideDiscount } from '~/constants/siteConfig';
import { CoreContext } from '@Hotels-at-Home/hah-fe-core/dist/context';

import { computedWithDiscount, computePrices } from '@Hotels-at-Home/hah-fe-core/dist/utils';
import { getPrices } from '@Hotels-at-Home/hah-fe-core/dist/utils/price';
import classNames from 'classnames';

interface IProps {
  promotion: IGetPromotionResponse;
}
const staticPrices = [
  // Bed category
  {
    maxRegular: 995,
    minRegular: 995,
    discount: sitewideDiscount,
    isPercentage: true,
  },
];

const HeroSection = ({ promotion }: IProps): ReactElement => {
  const { route } = useRouter();
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$heroSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$heroSection' });

  const router = useRouter();
  const {
    data: { currency },
  } = useContext(CoreContext);
  const prices = computedWithDiscount(staticPrices, promotion?.promo_is_active);
  const staticPrice = computePrices(prices)[0];

  const currentCurrency = currency;
  const price = getPrices(staticPrice[currentCurrency], router.locale);

  const windowSize = useWindowSize();
  const isSmallScreen = Boolean(windowSize.width) && windowSize.width <= MD_WIDTH;

  return (
    <section className="base-section hero-section main-hp hp-section mybed" id="hp-mybed">
      <div className="hero-section-container">
        <Link href={tLink('sofitelBed')} noTabbing ariaLabel={`${t('bedding')}`}>
          <div className="hero-video-container">
            <div
              className="video-wrapper"
              data-event-name="bloc_interact"
              data-bloc-name="homepage video"
            >
              <video
                key={isSmallScreen ? 'mobile' : 'desktop'}
                muted
                autoPlay
                loop
                playsInline
                className="hp-video"
                width="1920"
                height="730"
                poster="/video/shoppullman-hero-video-cover.webp"
                src={
                  isSmallScreen
                    ? '/video/shoppullman-hero-video-mobile.mp4'
                    : '/video/shoppullman-hero-video.mp4'
                }
              />
            </div>
          </div>
          <div className="hero-stack">
            <h1 className="hero-section-title italic">
              <Trans i18nKey="heading" t={t} components={{ span: <span /> }} />
            </h1>
            <div className="hero-stack-bottom">
              <p className="hero-description">{t('description')}</p>
              <div className="hero-cta">
                <div className={classNames('price', currentCurrency.toLowerCase())}>
                  {t('from')} {price.newPrice}
                </div>
                <Button variant="plain">{tButton('shopNow')}</Button>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default HeroSection;
